'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locales = [{
  country: 'ar',
  language: 'en',
  label: 'Argentina (in English)'
}, {
  country: 'ar',
  language: 'es',
  label: 'Argentina (en español)'
}, {
  country: 'au',
  language: 'en',
  label: 'Australia (in English)'
}, {
  country: 'at',
  language: 'de',
  label: 'Austria (auf Deutsch)'
}, {
  country: 'at',
  language: 'en',
  label: 'Austria (in English)'
}, {
  country: 'be',
  language: 'nl',
  label: 'Belgium (in het Nederlands)'
}, {
  country: 'be',
  language: 'fr',
  label: 'Belgium (en français)'
}, {
  country: 'be',
  language: 'en',
  label: 'Belgium (in English)'
}, {
  country: 'br',
  language: 'en',
  label: 'Brazil (in English)'
}, {
  country: 'br',
  language: 'pt',
  label: 'Brazil (em Português)'
}, {
  country: 'ca',
  language: 'en',
  label: 'Canada (in English)'
}, {
  country: 'ca',
  language: 'fr',
  label: 'Canada (en français)'
}, {
  country: 'c2',
  language: 'en',
  label: 'China Worldwide (in English)'
}, {
  country: 'c2',
  language: 'zh',
  label: 'China Worldwide (中文)'
}, {
  country: 'cz',
  language: 'en',
  label: 'Czech Republic (English)'
}, {
  country: 'cz',
  language: 'cs',
  label: 'Czech Republic (Czech)'
}, {
  country: 'dk',
  language: 'en',
  label: 'Denmark (in English)'
}, {
  country: 'dk',
  language: 'da',
  label: 'Denmark (i dansk)'
}, {
  country: 'ie',
  language: 'en',
  label: 'European Union (in English)'
}, {
  country: 'va',
  language: 'en',
  label: 'European Union - Send Only (in English)'
}, {
  country: 'fi',
  language: 'en',
  label: 'Finland (in English)'
}, {
  country: 'fi',
  language: 'fi',
  label: 'Finland (Finnish)'
}, {
  country: 'fr',
  language: 'fr',
  label: 'France (en français)'
}, {
  country: 'fr',
  language: 'en',
  label: 'France (in English)'
}, {
  country: 'de',
  language: 'de',
  label: 'Germany (auf Deutsch)'
}, {
  country: 'de',
  language: 'en',
  label: 'Germany (in English)'
}, {
  country: 'gr',
  language: 'en',
  label: 'Greece (English)'
}, {
  country: 'gr',
  language: 'el',
  label: 'Greece (Greek)'
}, {
  country: 'hk',
  language: 'zh',
  label: 'Hong Kong (中文)'
}, {
  country: 'hk',
  language: 'en',
  label: 'Hong Kong (in English)'
}, {
  country: 'hu',
  language: 'en',
  label: 'Hungary (English)'
}, {
  country: 'hu',
  language: 'hu',
  label: 'Hungary (Hungarian)'
}, {
  country: 'in',
  language: 'en',
  label: 'India (in English)'
}, {
  country: 'il',
  language: 'en',
  label: 'Israel (in English)'
}, {
  country: 'il',
  language: 'he',
  label: 'Israel (בעברית)',
  dir: 'rtl'
}, {
  country: 'it',
  language: 'it',
  label: 'Italy (in Italiano)'
}, {
  country: 'it',
  language: 'en',
  label: 'Italy (in English)'
}, {
  country: 'jp',
  language: 'ja',
  label: 'Japan (日本語)'
}, {
  country: 'jp',
  language: 'en',
  label: 'Japan (in English)'
}, {
  country: 'lu',
  language: 'en',
  label: 'Luxembourg (in English)'
}, {
  country: 'mx',
  language: 'es',
  label: 'Mexico (en Español)'
}, {
  country: 'mx',
  language: 'en',
  label: 'Mexico (in English)'
}, {
  country: 'nl',
  language: 'nl',
  label: 'Netherlands (in het Nederlands)'
}, {
  country: 'nl',
  language: 'en',
  label: 'Netherlands (in English)'
}, {
  country: 'no',
  language: 'en',
  label: 'Norway (in English)'
}, {
  country: 'no',
  language: 'no',
  label: 'Norway (i norsk)'
}, {
  country: 'pl',
  language: 'pl',
  label: 'Poland (po polsku)'
}, {
  country: 'pl',
  language: 'en',
  label: 'Poland (in English)'
}, {
  country: 'pt',
  language: 'en',
  label: 'Portugal (in English)'
}, {
  country: 'pt',
  language: 'pt',
  label: 'Portugal (em Português)'
}, {
  country: 'ru',
  language: 'en',
  label: 'Russia (in English)'
}, {
  country: 'ru',
  language: 'ru',
  label: 'Russia (на русском)'
}, {
  country: 'sk',
  language: 'en',
  label: 'Slovakia (English)'
}, {
  country: 'sk',
  language: 'sk',
  label: 'Slovakia (Slovak)'
}, {
  country: 'es',
  language: 'es',
  label: 'Spain (en Español)'
}, {
  country: 'es',
  language: 'en',
  label: 'Spain (in English)'
}, {
  country: 'se',
  language: 'en',
  label: 'Sweden (in English)'
}, {
  country: 'se',
  language: 'sv',
  label: 'Sweden (på svenska)'
}, {
  country: 'ch',
  language: 'de',
  label: 'Switzerland (auf Deutsch)'
}, {
  country: 'ch',
  language: 'en',
  label: 'Switzerland (in English)'
}, {
  country: 'tw',
  language: 'en',
  label: 'Taiwan (in English)'
}, {
  country: 'tw',
  language: 'zh',
  label: 'Taiwan (中文)'
}, {
  country: 'uk',
  language: 'en',
  label: 'United Kingdom (in English)'
}, {
  country: 'us',
  language: 'en',
  label: 'United States (in English)'
}, {
  country: 'al',
  language: 'en',
  label: 'Other Countries (in English)'
}, {
  country: 'ae',
  language: 'ar',
  label: 'Other Countries (in Arabic)'
}, {
  country: 'ae',
  language: 'es',
  label: 'Other Countries (in Spanish)'
}];

exports.default = locales;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/enhanced-legal/js/locales.js
// module id = 1086
// module chunks = 4